module.exports = __webpack_public_path__ + "img/advance1.947c6491.png";